import { PageDescription } from '@reflex/ui/components/layout/Typography';

export function LogEmptyState({ children }: { children: React.ReactNode }) {
  return <PageDescription className="text-xs py-4 text-center">{children}</PageDescription>;
}
